import { shallowRef } from '@vue/composition-api'
import { pick } from 'lodash-es'
import { fetchSportsProduct } from '@ms/api/match'
import { batchUpdateSportsMap } from '../map.js'

// prematch sports
export default function usePrematchSports() {
  const C_PREMATCH_SPORTS = 'C_PREMATCH_SPORTS'
  const prematchSports = shallowRef([])

  // update from cache
  const getPrematchSportsCache = async () => {
    const data = sessionStorage.getItem(C_PREMATCH_SPORTS)
    if (data) {
      const list = JSON.parse(data)
      prematchSports.value = list
      batchUpdateSportsMap(list)
      return Promise.resolve()
    }

    return Promise.reject(new Error('no cache'))
  }

  const parseRes = (sports) => {
    const keys = ['sportId', 'sportName']
    const list = sports.map((x) => pick(x, keys))
    prematchSports.value = list
    sessionStorage.setItem(C_PREMATCH_SPORTS, JSON.stringify(list))
  }

  const reqSports = async () => {
    const { data } = await fetchSportsProduct(3)
    parseRes(data.sports)
    batchUpdateSportsMap(data.sports)
  }

  // fetch realsport prematch sports list
  const fetchPrematchSports = async () => Promise.any([getPrematchSportsCache(), reqSports()])

  const setBffPrematchSports = (data) => {
    parseRes(data.sports)
  }

  return {
    prematchSports,
    fetchPrematchSports,
    setBffPrematchSports
  }
}
